import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'

export default defineNuxtRouteMiddleware(async (to) => {
  const auth = useAutobidAuth()
  if (auth.returnUrl && auth.intent === 'logout') {
    const { path, query } = auth.returnUrl
    if (to.path !== path) {
      return await navigateTo({
        path,
        query,
      })
    }
  }
})
